import { getCountryCookie, getCurrencyCookie } from "shared/utils/cookies";

export const ONLINE_CHECKOUT_CURRENCIES = ["EUR"];

const getCountriesFromDom = () => {
  try {
    const el = document.getElementById('countries-object');
    if (!el) return [];
    return JSON.parse(el.innerHTML);
  } catch {
    return [];
  }
};

export const canCheckoutOnline = () => {
  const countries = getCountriesFromDom();
  const currentCountryCode = getCountryCookie();
  const country = countries.find(c => c.id === currentCountryCode);
  return country?.shippingEnabled && ONLINE_CHECKOUT_CURRENCIES.includes(getCurrencyCookie());
};
